// ---- Music Tracking Types ----

export type ListenStatus = "want_to_listen" | "listening" | "listened";

export const MUSIC_GENRES = [
  "Pop", "Rock", "Hip-Hop", "R&B", "Jazz", "Classical", "Electronic",
  "Country", "Folk", "Indie", "Metal", "Punk", "Soul", "Reggae",
  "Blues", "Latin", "K-Pop", "Soundtrack", "Podcast", "Other",
] as const;

export type MusicGenre = (typeof MUSIC_GENRES)[number];

export type MusicItem = {
  id: string;
  userId: string;
  title: string;              // song or album title
  artist?: string;
  albumArt?: string;          // cover image URL
  genre?: string;
  type?: "song" | "album" | "podcast";  // what kind of media
  status: ListenStatus;
  rating?: number;            // 1-5 stars
  review?: string;
  dateAdded: string;
  dateStarted?: string;       // when moved to "listening"
  dateListened?: string;      // when moved to "listened"
};

export type CatalogMusic = {
  id: string;
  title: string;
  titleLower: string;
  artist?: string;
  artistLower?: string;
  albumArt?: string;
  genre?: string;
  type?: "song" | "album" | "podcast";
  addedBy: string;
  listenersCount: number;
  avgRating: number;
  totalRatings: number;
  createdAt: string;
  updatedAt: string;
};
